export const chatMessageMixin = {
    mixins: [],
    props: {
    },
    data: function() {
        return {
        }
    },
    computed: {
        isHostMessage: function() {
            return this.isMessageHostMessage(this.message);
        },
        isGuestMessage: function() {
            return this.isMessageGuestMessage(this.message);
        },
        isSystemMessage: function() {
            return this.isMessageSystemMessage(this.message);
        },
        isContentTypeText: function() {
            return this.isMessageContentTypeText(this.message);
        },
        isContentTypeMedia: function() {
            return this.isMessageContentTypeMedia(this.message);
        },
        isContentTypeFormInvite: function() {
            return this.isMessageContentTypeFormInvite(this.message);
        },
        isContentTypeLocation: function() {
            return this.isMessageContentTypeLocation(this.message);
        },
        isRead: function() {
            return this.isMessageRead(this.message);
        },
        isDelivered: function() {
            return this.isMessageDelivered(this.message);
        },
        isUndelivered: function() {
            return this.isMessageUndelivered(this.message);
        },
        isFailed: function() {
            return this.isMessageFailed(this.message);
        },
        hasMedia: function() {
            return this.messageHasMedia(this.message);
        },
        hasActions: function() {
            return this.messageHasActions(this.message);
        }
    },
    methods: {
        isMessageHostMessage: function(message) {
            return (message && message.sentBy === 'host');
        },
        isMessageGuestMessage: function(message) {
            return (message && message.sentBy === 'guest');
        },
        isMessageSystemMessage: function(message) {
            return (message && message.sentBy === 'system');
        },
        isMessageContentTypeText: function(message) {
            return (message && message.contentType === 'text');
        },
        isMessageContentTypeMedia: function(message) {
            return (message && message.contentType === 'media');
        },
        isMessageContentTypeFormInvite: function(message) {
            return (message && message.contentType === 'form-invite');
        },
        isMessageContentTypeLocation: function(message) {
            return (message && message.contentType === 'location');
        },
        isMessageRead: function(message) {
            return (message && message.status === 'read');
        },
        isMessageDelivered: function(message) {
            return (message && message.status === 'delivered');
        },
        isMessageUndelivered: function(message) {
            return (message && message.status === 'undelivered');
        },
        isMessageFailed: function(message) {
            return (message && message.status === 'failed');
        },
        messageHasMedia: function(message) {
            return (message && message.media && message.media.length > 0);
        },
        messageHasActions: function(message) {
            return (message && message.actions && message.actions.length > 0);
        }
    },
}